import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Hero {
	constructor() {
		this.hero = document.querySelector('[data-hero-container]')
		this.tl = null
		if (!this.hero) return

		this.video = this.#getElement('video') ?? this.#getElement('img')
		this.container = this.#getElement('.container')

		this.#init()
	}

	#init() {
		this.#setupScrollTrigger()
	}

	#setupScrollTrigger() {
		this.tl = gsap
			.timeline({
				scrollTrigger: {
					trigger: this.hero,
					pin: true,
					pinSpacing: false,
					scrub: true,
					start: 'top top',
					end: () => {
						return `+=${this.hero.getBoundingClientRect().height}`
					},
				},
				defaults: {
					ease: 'none',
				},
			})
			.to(this.video, { yPercent: -50 })
			.to(
				this.container,
				{
					y: () => {
						return -this.hero.getBoundingClientRect().height * 0.7
					},
				},
				'<='
			)
	}

	#getElement(selector) {
		return this.hero.querySelector(selector)
	}

	destroy() {
		if (this.tl) {
			this.tl.scrollTrigger?.kill()
			this.tl.kill()
			this.tl = null
		}
	}
}
